import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import Collapse from "@mui/material/Collapse";
import {
  TableCell,
  Button,
  Stack,
  Typography,
  Link,
  Tooltip,
  Modal as MuiModal,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {
  MdSchedule,
  MdKeyboardArrowDown,
  MdKeyboardArrowRight,
} from "react-icons/md";
import { GrUnorderedList } from "react-icons/gr";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { tableCellClasses } from "@mui/material/TableCell";
import { createStyles, withStyles } from "@mui/styles";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { useSnackbar } from "notistack";
import GreenChip from "../chips/GreenChip";
import YellowChip from "../chips/YellowChip";
import RedChip from "../chips/RedChip";
import BlueChip from "../chips/BlueChip";
import {
  DataProcessorApi,
  getNodeStatus,
} from "../../services/DataProcessorApi";
import { WorkflowApi } from "../../services/WorkflowApi";
// import convertToRequiredFormat from '../components/react-flow/JsonConverter';
// import { fetchExecutionListApi, updateExecution } from "../api's/ExecutionApi";
import LoadingIcon from "../../reusable-component/LoadingIcon";
// import RunModal from '../components/ruleEngine/RunModal';
// import FileDialog from './FileDialog';
import { WorkflowContext } from "../../contexts/WorkflowProvider";
import BasicMenu from "../../reusable-component/BasicMenu";
import { useAxios } from "../../contexts/AxiosProvider";
import Cron from "../cron/Cron";
import { DatePicker, Modal as AntdModal } from "antd";
import { getEnvironmentConfig } from "../../constants/CloudConstant";
import { format, toZonedTime } from "date-fns-tz";

export default function AccordionTable({
  data,
  rowsPerPage,
  page,
  workflowData,
  userData,
  fetchAllWorkflows,
}) {
  const navigate = useNavigate();
  const axios = useAxios();
  const [loading, setLoading] = useState(false);
  const { setWorkflow } = useContext(WorkflowContext);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      background: "none !important",
      color: "#8798AD",
      padding: "8px",
      textTransform: "uppercase",
      fontSize: 12,
      fontWeight: 640,
      textAlign: "center",
      position: "sticky",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      padding: "10px",
      textAlign: "center",
    },
  }));

  const StyledTableRow = withStyles((theme) =>
    createStyles({
      root: {
        border: "1px solid white",
        background: "#FFFFFF",
        boxShadow: "0px 2px 6px #0000000A",
        borderRadius: "5px !important",
      },
    })
  )(TableRow);

  Row.propTypes = {
    row: PropTypes.shape({
      workflow_name: PropTypes.string.isRequired,
      process_type: PropTypes.string.isRequired,
      engagement_name: PropTypes.string.isRequired,
      client_name: PropTypes.string.isRequired,
      created_by: PropTypes.string.isRequired,
      created_at: PropTypes.string.isRequired,
      execution_mode: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      executionInfoDto: PropTypes.arrayOf(
        PropTypes.shape({
          workflow_type: PropTypes.string.isRequired,
          execution_engine: PropTypes.string.isRequired,
          last_executed_on: PropTypes.string.isRequired,
          execution_status: PropTypes.string.isRequired,
          executed_by: PropTypes.string.isRequired,
          created_by: PropTypes.string.isRequired,
          scheduled_on: PropTypes.string.isRequired,
          runDisabled: PropTypes.string.isRequired,
        })
      ).isRequired,
    }).isRequired,
  };

  function Row(props) {
    const { enqueueSnackbar } = useSnackbar();
    const { row } = props;
    const [openData, setOpenData] = useState(false);
    const CRON_INITIAL_STATE = {
      workflow_id: "",
      execution_mode: "Batch",
      workflow_type: "",
    };
    const [cronData, setcronData] = useState(CRON_INITIAL_STATE);
    const [openCronDialog, setOpenCronDialog] = useState(false);

    const EXECUTION_WORKFLOW_INITIAL_STATE = {
      workflow_id: "",
      workflow_name: "",
    };

    const [executionWorkflow, setexecutionWorkflow] = useState(
      EXECUTION_WORKFLOW_INITIAL_STATE
    );

    const [isRunDatePickerOpen, setIsRunDatePickerOpen] = useState(false);
    const [datePicked, setDatePicked] = useState("");

    const openDatePickerModal = (e, workflow_id, workflow_name) => {
      setexecutionWorkflow({
        ...executionWorkflow,
        workflow_id: workflow_id,
        workflow_name: workflow_name,
      });
      setIsRunDatePickerOpen(true);
    };
    const handleOk = () => {
      // executeDataProcessor(datePicked)
      setIsRunDatePickerOpen(false);
      setexecutionWorkflow(EXECUTION_WORKFLOW_INITIAL_STATE);
      setDatePicked("");
    };
    const handleCancel = () => {
      setIsRunDatePickerOpen(false);
      setexecutionWorkflow(EXECUTION_WORKFLOW_INITIAL_STATE);
      setDatePicked("");
    };

    const onDateChange = (date, dateString) => {
      setDatePicked(dateString);
    };

    const [forceUpdate, setForceUpdate] = useState(0);

    const handleForceUpdate = () => {
      setForceUpdate((prevForceUpdate) => prevForceUpdate + 1);
      setOpenData(true);
    };

    const handleOpenScheduler = (e, workflow_id, workflow_type) => {
      setcronData({
        ...cronData,
        workflow_id: workflow_id,
        workflow_type: workflow_type,
      });
      setOpenCronDialog(true);
    };

    const handleCloseScheduler = (value) => {
      handleRefreshWorkflow();
      setOpenCronDialog(false);
    };

    const handleViewLogs = (workflow_type) => {
      const newState = {
        workflow_id: row.workflow_id,
        workflow_name: row.workflow_name,
        client_name: row.client_name,
        engagement_name: row.engagement_name,
        domain_name: row.domain_name,
        created_by: row.created_by,
        created_at: row.created_at,
        status: row.status,
        workflow_type,
        cloudEnvironment: row.cloudEnvironment,
        ...userData,
      };
      navigate(
        `/dep/workflow/${workflowData.engagement_id}/${workflowData.processType}/logs/${workflow_type}`,
        {
          state: newState,
        }
      );
    };

    const navigateToWorkflow = async (e, row) => {
      e.preventDefault();
      sessionStorage.removeItem("allNodes");
      sessionStorage.removeItem("node");
      sessionStorage.removeItem("elementCount");
      sessionStorage.removeItem("saved_node");
      sessionStorage.removeItem("edges");
      setLoading(true);
      const response = await WorkflowApi.getWorkflowById(
        axios,
        row.workflow_id
      );
      setWorkflow(response.data);
      let result, nodeStatus;
      try {
        result = await DataProcessorApi.getDataProcessor(
          axios,
          row.workflow_id,
          row.execution_mode
        );
        nodeStatus = await getNodeStatus(
          axios,
          response.data.engagement.clientEntity.clientName,
          response.data.engagement.engagementName,
          response.data.workflow_name,
          response.data.cloudEnvironment
        );
      } catch (error) {}
      if (response.status === 200) {
        if (result) {
          let elemCount = 0;

          const newSavedElement = [];

          console.log(result);

          result.data.nodes.forEach((el) => {
            el["nodeId"] = `${el.nodeId}`;
            elemCount++;
            newSavedElement.push(el.id);
          });

          sessionStorage.setItem(
            "allNodes",
            JSON.stringify(result.data.form_data)
          );
          sessionStorage.setItem("elementCount", elemCount);
          sessionStorage.setItem("node", JSON.stringify(result.data.nodes));
          sessionStorage.setItem("edges", JSON.stringify(result.data.edges));
          sessionStorage.setItem("saved_node", JSON.stringify(newSavedElement));
          nodeStatus &&
            sessionStorage.setItem(
              "nodeStatus",
              JSON.stringify(nodeStatus.data)
            );
        }
        const newRow = { ...row };
        const newState = {
          workflow_name: newRow.workflow_name,
          client_name: newRow.client_name,
          engagement_name: newRow.engagement_name,
          created_by: newRow.created_by,
          created_at: newRow.created_at,
          status: newRow.status,
          workflow_data: response.data,
          ...userData,
        };

        navigate(
          `/dep/workflow/${workflowData.engagement_id}/${response.data.process_type}/onboarding/${newRow.workflow_name}`,
          {
            state: newState,
          }
        );
      }
      setLoading(false);
    };

    const handleRefreshWorkflow = async () => {
      try {
        const response = await WorkflowApi.refreshWorkflow(
          axios,
          row.workflow_id
        );
        handleForceUpdate();
        if (response.status === 200) {
          row.executionInfoDto = response.data;
          // setOpenData(false);
          enqueueSnackbar("Status Refreshed!", {
            variant: "success",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        }
      } catch (error) {
        console.log(error);
        if (error.response.status === 500) {
          enqueueSnackbar("Internal Server Error", {
            variant: "error",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        }
      }
    };

    const formattedDate = (dateString) => {
      if (!dateString) return "";
      const zonedDate = toZonedTime(dateString, "America/New_York");
      return format(zonedDate, "MMM dd, yyyy HH:mm:ss");
    };

    return (
      <>
        <StyledTableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <StyledTableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpenData(!openData)}
            >
              {openData ? (
                <MdKeyboardArrowDown size={15} />
              ) : (
                <MdKeyboardArrowRight size={15} />
              )}
            </IconButton>
          </StyledTableCell>
          <StyledTableCell>
            {row.status === "approved" ? (
              <Link
                component="button"
                variant="body2"
                onClick={(e) => {
                  navigateToWorkflow(e, row);
                }}
              >
                {row.workflow_name}
              </Link>
            ) : (
              row.workflow_name
            )}
          </StyledTableCell>
          <StyledTableCell>{row.process_type}</StyledTableCell>
          <StyledTableCell>{row.engagement_name}</StyledTableCell>
          <StyledTableCell>{row.client_name}</StyledTableCell>
          <StyledTableCell>{row.created_by}</StyledTableCell>
          <StyledTableCell>{formattedDate(row.created_at)}</StyledTableCell>
          <StyledTableCell>
            {row.status === "approved" ? (
              <GreenChip title="approved" />
            ) : row.status === "pending" ? (
              <YellowChip title="pending" />
            ) : (
              <RedChip title="rejected" />
            )}
          </StyledTableCell>
          <StyledTableCell>
            <BasicMenu
              row={row}
              axios={axios}
              type="Workflow"
              userData={userData}
              handleRefreshWorkflow={handleRefreshWorkflow}
              fetchAllWorkflows={fetchAllWorkflows}
            />
          </StyledTableCell>
        </StyledTableRow>
        <StyledTableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <StyledTableCell
            style={{ paddingBottom: 0, paddingTop: 0 }}
            colSpan={12}
          >
            <Collapse in={openData} timeout="auto" unmountOnExit>
              {row.executionInfoDto.length === 0 ? (
                <Typography
                  variant="h5"
                  component="h5"
                  gutterBottom
                  display="flex"
                  alignContent="center"
                  justifyContent="center"
                  fontWeight={600}
                >
                  No data to display
                </Typography>
              ) : (
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>WORKFLOW TYPE</StyledTableCell>
                      <StyledTableCell>EXECUTION ENGINE</StyledTableCell>
                      <StyledTableCell align="left">
                        LAST EXECUTED ON
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        EXECUTION STATUS
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        EXECUTED BY
                      </StyledTableCell>
                      <StyledTableCell align="left">SCHEDULED</StyledTableCell>
                      <StyledTableCell align="left">ACTION</StyledTableCell>
                      <StyledTableCell align="left">LOGS</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.executionInfoDto.map((historyRow) => (
                      <StyledTableRow key={historyRow.workflow_id}>
                        <StyledTableCell>
                          {historyRow.workflow_type}
                        </StyledTableCell>
                        {row.cloudEnvironment ===
                          getEnvironmentConfig().cloudEnvironment && (
                          <StyledTableCell>
                            {getEnvironmentConfig().connectionType || "--"}
                          </StyledTableCell>
                        )}
                        <StyledTableCell>
                          {(formattedDate(historyRow.last_executed_on) &&
                            formattedDate(historyRow.last_executed_on)) ||
                            "--"}
                        </StyledTableCell>
                        <StyledTableCell
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            flex: 1,
                            alignItems: "center",
                            border: "none",
                          }}
                        >
                          <Stack direction="row" spacing={1}>
                            {historyRow.execution_status.toLowerCase() ===
                            "completed" ? (
                              <GreenChip title="Completed" />
                            ) : historyRow.execution_status.toLowerCase() ===
                              "saved" ? (
                              <BlueChip title="Saved" />
                            ) : historyRow.execution_status.toLowerCase() ===
                              "running" ? (
                              <YellowChip title="Running" />
                            ) : (
                              <RedChip title="Failed" />
                            )}
                          </Stack>
                        </StyledTableCell>

                        <StyledTableCell align="left">
                          {historyRow.executed_by || "--"}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {historyRow.scheduled_on || "--"}
                        </StyledTableCell>
                        <>
                          <StyledTableCell align="left">
                            <Tooltip title="Schedule">
                              <Button
                                sx={{
                                  backgroundColor: "white",
                                  border: 1,
                                  borderColor: "black",
                                  maxWidth: "40px",
                                  maxHeight: "28px",
                                  minWidth: "40px",
                                  minHeight: "28px",
                                }}
                                onClick={(e) =>
                                  handleOpenScheduler(
                                    e,
                                    row.workflow_id,
                                    historyRow.workflow_type
                                  )
                                }
                              >
                                <MdSchedule size={20} color="black" />
                              </Button>
                            </Tooltip>
                          </StyledTableCell>
                          <StyledTableCell>
                            <Tooltip title="Logs">
                              <Button
                                sx={{
                                  backgroundColor: "white",
                                  border: 1,
                                  borderColor: "black",
                                  maxWidth: "40px",
                                  maxHeight: "28px",
                                  minWidth: "40px",
                                  minHeight: "28px",
                                }}
                                onClick={() =>
                                  handleViewLogs(historyRow.workflow_type)
                                }
                              >
                                <GrUnorderedList size={20} color="black" />
                              </Button>
                            </Tooltip>
                          </StyledTableCell>
                        </>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </Collapse>
          </StyledTableCell>
        </StyledTableRow>

        <MuiModal
          open={openCronDialog}
          onClose={handleCloseScheduler}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={{ zIndex: "1" }}
        >
          <Cron
            cronData={cronData}
            userData={userData}
            openCronDialog={openCronDialog}
            setOpenCronDialog={setOpenCronDialog}
          />
        </MuiModal>

        <AntdModal
          title="Select Date"
          open={isRunDatePickerOpen}
          onOk={handleOk}
          okText="RUN"
          onClose={handleCancel}
        >
          <DatePicker
            format={{ format: "YYYY/MM/DD" }}
            onChange={onDateChange}
          />
        </AntdModal>
      </>
    );
  }

  return (
    <>
      <TableContainer>
        <Table
          aria-label="collapsible table"
          style={{
            minWidth: 650,
            borderSpacing: "0px 4px",
            borderCollapse: "separate",
          }}
        >
          <TableHead>
            <TableRow>
              <StyledTableCell> </StyledTableCell>
              <StyledTableCell>Workflow Name</StyledTableCell>
              <StyledTableCell>Process Type</StyledTableCell>
              <StyledTableCell>PIPELINE NAME</StyledTableCell>
              <StyledTableCell>SUB-FUNCTION NAME</StyledTableCell>
              <StyledTableCell>CREATED BY</StyledTableCell>
              <StyledTableCell>CREATED ON</StyledTableCell>
              <StyledTableCell>STATUS</StyledTableCell>
              <StyledTableCell>ACTION</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data
              ?.slice(
                (page - 1) * rowsPerPage,
                (page - 1) * rowsPerPage + rowsPerPage
              )
              .map((row) => (
                <Row key={row.name} row={row} />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      {loading && <LoadingIcon />}
    </>
  );
}
